let featuredData = [{
    id: 1,
    name: "Burnikk",
    brand: "Sexbomb",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 240,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2F7l3FMZqY8JdfssalDgx2?alt=media&token=be15689c-e12c-4829-9d78-32395ef1e3f7",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
      "rgb(247, 8, 8)",
      "rgb(9, 225, 182)",
      "rgb(255, 111, 0)",
    ],
    added: false,
    parameter: '7l3FMZqY8JdfssalDgx2'
  },
  {
    id: 2,
    name: "Kibal Batal",
    brand: "Kibal Black",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 674,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FALz5M4DI7MF7CdZrq3gS?alt=media&token=8d33ea34-2de3-466b-9b3d-27015e9cd540",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
      "rgb(253, 138, 8)",
      "rgb(255, 82, 183)",
    ],
    parameter: 'ALz5M4DI7MF7CdZrq3gS'
  },
  {
    id: 3,
    name: "Very Nice",
    brand: "Salt Maalat",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 79,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FLIu8tS4yHSU28Xi8BXCj?alt=media&token=31e796ad-dbd6-4e4f-a8a9-192f5158684a",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(132, 3, 9)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
      "rgb(3, 215, 252)",
      "rgb(12, 228, 26)",
    ],
    parameter: 'LIu8tS4yHSU28Xi8BXCj'
  
  }, {
    id: 4,
    name: "Buldit",
    brand: "Salt Maalat",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 250,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FYVPdTsyxJybMCsdKpXhq?alt=media&token=23d7673c-a0bf-4dcb-89f1-8482446b56be",
    size: [28, 36, 42],
    color: ["rgb(202, 80, 247)", "rgb(45, 72, 210)", "rgb(255, 141, 10)"],
    parameter: 'YVPdTsyxJybMCsdKpXhq'
  
  }, {
    id: 5,
    name: "Balakubak",
    brand: "Betsin Maalat",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 170,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FYZ7LM3vZjWbIIJH2tgEb?alt=media&token=5e722063-a792-4502-9f6e-c3df1581aa9c",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(132, 3, 9)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
    ],
    parameter: 'YZ7LM3vZjWbIIJH2tgEb'
  
  }, {
    id: 6,
    name: "Tiktilaok Manok",
    brand: "Sexbomb",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 78,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FbS1hHdO7NvbR1yN5ZPlR?alt=media&token=809a3249-f83d-4aec-b134-34a65ce2ce10",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(132, 3, 9)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
    ],
    parameter: 'bS1hHdO7NvbR1yN5ZPlR'
  
  },
  {
    id: 7,
    name: "Kutu",
    brand: "Sexbomb",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 129,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2Fc0cvo2QXFMX1wO7EpvQC?alt=media&token=7115b501-723c-4fd3-9c00-e709ad38bd8a",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(132, 3, 9)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
    ],
    parameter: 'c0cvo2QXFMX1wO7EpvQC'
  
  },
  {
    id: 8,
    name: "Quake Overload",
    brand: "Salt",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 80,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FcLGc3mcbZrK3Tl3yJ3xW?alt=media&token=44f74e92-f2ca-4af3-82f6-7a3bcace7f7a",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(132, 3, 9)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
      "rgb(3, 215, 252)",
      "rgb(12, 228, 26)",
    ],
    parameter: 'cLGc3mcbZrK3Tl3yJ3xW'
  },
  ]
  export default function shareFeatured () {
    return featuredData
  }